<template>
    <v-navigation-drawer
            :mini-variant.sync="mini"
            app
            fixed
            id="app-drawer"
            v-model="drawer"
            width="260"
    >
        <v-toolbar
                color="primary"
                dark
        >
            <img
                    alt="Admin Template"
                    height="36"
                    :src="logo"
            >
            <v-toolbar-title class="ml-0 pl-3">
                <span class="hidden-sm-and-down">Menu</span>
            </v-toolbar-title>
        </v-toolbar>
        <vue-perfect-scrollbar
                :settings="scrollSettings"
                class="drawer-menu--scroll"
        >
            <v-list
                    dense
                    expand
            >
                <template v-for="(item,i) in menu">
                    <v-subheader
                            :key="i"
                            v-if="item.header"
                    >
                        {{ item.header }}
                    </v-subheader>
                    <v-divider
                            :key="i"
                            v-else-if="item.divider"
                    />
                    <!--                    <v-list-group-->
                    <!--                            :group="item.group"-->
                    <!--                            :key="item.name"-->
                    <!--                            :prepend-icon="item.icon"-->
                    <!--                            no-action="no-action"-->
                    <!--                            v-else-if="item.entities"-->
                    <!--                            value="true"-->
                    <!--                    >-->
                    <!--                        <template v-slot:activator>-->
                    <!--                            <v-list-item-title v-text="item.title"></v-list-item-title>-->
                    <!--                            <template v-for="(subitem) in item.entities">-->
                    <!--                                <v-list-item :key="subitem.name" :value="subitem">-->
                    <!--                                    <v-list-item-content>-->
                    <!--                                        <v-list-item-title v-text="subitem.title"></v-list-item-title>-->
                    <!--                                    </v-list-item-content>-->
                    <!--                                </v-list-item>-->

                    <!--                            </template>-->
                    <!--                        </template>-->
                    <!--                    </v-list-group>-->
                    <v-list-item
                            :href="item.href"
                            :key="item.name"
                            :target="item.target"
                            :to="!item.href ? { name: item.name } : null"
                            :value="item"
                            v-else
                    >
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="item.title"/>
                    </v-list-item>
                </template>
            </v-list>
        </vue-perfect-scrollbar>
    </v-navigation-drawer>
</template>

<script>

    import {Menu} from "../../router/menu";
    import VuePerfectScrollbar from "vue-perfect-scrollbar";

    export default {
        name: "NavigationBar",
        components: {
            VuePerfectScrollbar
        },
        props: {
            expanded: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            mini: false,
            drawer: true,
            menu: Menu,
            scrollSettings: {
                maxScrollbarLength: 160
            }
        }),
        created() {
            window.app.$on("APP_DRAWER_TOGGLED", () => {
                this.drawer = !this.drawer;
            });
        },
        computed: {
            logo() {
                return require("@/assets/logo.png");
            }
        },
    }
</script>

<style lang="stylus" scoped>
    #app-drawer
        overflow: hidden

        .drawer-menu--scroll
            height: calc(100vh - 48px)
            overflow: auto
</style>